// extracted by mini-css-extract-plugin
export default {"email-buttons":"_-web-client-js-react-components-___PersonDetailsModal-module__email-buttons___1LdGQ"};